
export const CompaniesCardItem = ({ logo, title, description }) => {
    return (
        <div className="bg-white rounded-[48px] shadow-md p-6 max-w-sm">
            <div className="flex items-center gap-3 mb-4">
                <img src={logo} alt={title} className="w-10 h-10 object-contain" />
                <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
            </div>
            <p className="text-gray-600 text-sm">{description}</p>
        </div>
    );
};
